import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import GalleryManagement from '../components/admin/GalleryManagement';
import ProfileManagement from '../components/admin/ProfileManagement';
import TestimonialsManagement from '../components/admin/TestimonialsManagement';

const AdminPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('gallery');

  return (
    <Layout>
      <div className="bg-light min-h-screen">
        <div className="container mx-auto px-4 py-12">
          <h1 className="text-4xl font-black mb-10 text-black">Admin Dashboard</h1>

          <div className="bg-white border-2 border-black mb-8">
            <div className="flex flex-wrap border-b-2 border-black">
              <button
                className={`py-4 px-8 font-semibold text-lg ${
                  activeTab === 'gallery'
                    ? 'text-white bg-black'
                    : 'text-black hover:bg-gray-100'
                }`}
                onClick={() => setActiveTab('gallery')}
              >
                Gallery Management
              </button>
              <button
                className={`py-4 px-8 font-semibold text-lg ${
                  activeTab === 'profile'
                    ? 'text-white bg-black'
                    : 'text-black hover:bg-gray-100'
                }`}
                onClick={() => setActiveTab('profile')}
              >
                Profile Management
              </button>
              <button
                className={`py-4 px-8 font-semibold text-lg ${
                  activeTab === 'testimonials'
                    ? 'text-white bg-black'
                    : 'text-black hover:bg-gray-100'
                }`}
                onClick={() => setActiveTab('testimonials')}
              >
                Testimonials
              </button>
            </div>
          </div>

          {activeTab === 'gallery' && <GalleryManagement />}
          {activeTab === 'profile' && <ProfileManagement />}
          {activeTab === 'testimonials' && <TestimonialsManagement />}
        </div>
      </div>
    </Layout>
  );
};

export default AdminPage;